module.exports = __webpack_public_path__ + "img/result-detail-communication-outleft02.a6764b1a.svg";